import { render, staticRenderFns } from "./DataTableInputCollapse.vue?vue&type=template&id=13265890&scoped=true"
import script from "./DataTableInputCollapse.vue?vue&type=script&lang=js"
export * from "./DataTableInputCollapse.vue?vue&type=script&lang=js"
import style0 from "./DataTableInputCollapse.vue?vue&type=style&index=0&id=13265890&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13265890",
  null
  
)

export default component.exports